export class RecaptchaState {
  active: boolean;

  constructor() {
    this.active = false;
  }
}
